import { render, staticRenderFns } from "./ResendTest.vue?vue&type=template&id=7be0a37c&"
import script from "./ResendTest.vue?vue&type=script&lang=js&"
export * from "./ResendTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports